export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/about-service-1.78464826-fdb070.png";